var _Pipeline_logger, _Pipeline_queue;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { isFunction } from '../TypeHelpers';
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
export default class Pipeline {
    constructor(logger) {
        _Pipeline_logger.set(this, void 0);
        _Pipeline_queue.set(this, void 0);
        __classPrivateFieldSet(this, _Pipeline_logger, logger.scope('Pipeline'), "f");
        __classPrivateFieldSet(this, _Pipeline_queue, [], "f");
    }
    start(task) {
        if (isFunction(task)) {
            const pTask = {
                name: task.toString(),
                async executeAsync(context) {
                    await task(context);
                }
            };
            __classPrivateFieldGet(this, _Pipeline_queue, "f").push(pTask);
        }
        else {
            __classPrivateFieldGet(this, _Pipeline_queue, "f").push(task);
        }
        return this;
    }
    then(task) {
        if (isFunction(task)) {
            const pTask = {
                name: task.toString(),
                async executeAsync(context) {
                    await task(context);
                }
            };
            __classPrivateFieldGet(this, _Pipeline_queue, "f").push(pTask);
        }
        else {
            __classPrivateFieldGet(this, _Pipeline_queue, "f").push(task);
        }
        return this;
    }
    async executeAsync(context) {
        const queue = [...__classPrivateFieldGet(this, _Pipeline_queue, "f")];
        const logger = __classPrivateFieldGet(this, _Pipeline_logger, "f").scope('Execute');
        logger.debug(`Starting Pipeline`);
        while (queue.length > 0) {
            const curr = queue.shift();
            if (!isUndefinedOrNull(curr)) {
                logger.debug(`Executing ${curr.name}`);
                await curr.executeAsync(context);
                logger.debug(`Completed ${curr.name}`);
            }
        }
        logger.debug(`Finished Pipeline`);
    }
}
_Pipeline_logger = new WeakMap(), _Pipeline_queue = new WeakMap();
